import HomePage from '../pages/HomePage'
import Industrial from '../pages/Industrial'
import FishFarming from '../pages/FishFarming'
import MarineNavy from '../pages/MarineNavy'
import OilSpill from '../pages/OilSpill'
import Pumps from '../pages/Pumps'
import NotFound from '../pages/404'

export const routes = [
    {
        path:'/:lang?',
        name: 'HomePage',
        component: HomePage
    },
    {
        path:'/:lang?/Industrial',
        name: 'Industrial',
        component: Industrial
    },
    {
        path:'/:lang?/FishFarming',
        name: 'FishFarming',
        component: FishFarming
    },   
    {
        path:'/:lang?/MarineNavy',
        name: 'MarineNavy',
        component: MarineNavy
    },{
        path:'/:lang?/OilSpill',
        name: 'OilSpill',
        component: OilSpill
    },{
        path:'/:lang?/Pumps',
        name: 'Pumps',
        component: Pumps
    },
    {
        path:'*',
        name: 'NotFound',
        component: NotFound
    },
];